import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import { deleteScholarship, getColleges, getCourseCategories, getCourses, getScholarship, getUniversities, updateScholarship } from "../../Services/HomeService";
import moment from "moment";
import HttpClientXml from "../../utils/HttpClientXml";
import Swal from "sweetalert2";
import "./Style.css"
import Select from "react-select";
import { cropWords, getPlainTextFromHtml } from "../../utils/Helper";
import ReactQuill from "react-quill";

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};


const ManageScholarship = () => {
  const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "rgb(131, 144, 155)",
    margin: "0px 0px 10px 0px",
    fontWeight: "bold",
  };
  const customStyles = {
    headCells: {
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        color: "#333",
      },
    },
  };

  const initialValues = {
    schemeName: "",
    shortDescription: "",
    longDescription: "",
    eligibilityCriteria: "",
    benefits: ""
  }

  const fileInputRef = useRef(null);
  const [universities, setUniversities] = useState([]);
  const [fetchUniversitiesLoading, setFetchUniversitiesLoading] = useState(false);
  const [colleges, setColleges] = useState([]);
  const [fetchCollegesLoading, setFetchCollegesLoading] = useState(false);
  const [courseCategories, setCourseCategories] = useState([]);
  const [fetchCourseCategoriesLoading, setCourseCategoriesLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [fetchCoursesLoading, setFetchCoursesLoading] = useState(false);
  const [uploading, setUploading] = useState(false)

  const [updateLoading, setUpdateLoading] = useState(false);
  const [updateId, setUpdateId] = useState(null)
  const [formData, setFormData] = useState(initialValues)

  const [fetchLoading, setFetchLoading] = useState(false);
  const [allData, setAllData] = useState([])

  const fetchAllData = async () => {
    try {
      setFetchLoading(true);
      const res = await getScholarship();
      console.log("fetched Scholarship", res?.data);
      if (res?.status) {
        setAllData(res?.data);
        setFetchLoading(false);
      } else {
        toast.error("Error while Fetching Scholarship Data");
        setFetchLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Scholarship Data");
      console.error("Error fetching Scholarship:", error);
      setFetchLoading(false);
    }
  };

  const fetchUniversities = async () => {
    try {
      setFetchUniversitiesLoading(true);
      const res = await getUniversities();
      console.log("fetched Universities", res?.data);
      if (res?.status) {
        setUniversities(res?.data);
        setFetchUniversitiesLoading(false);
      } else {
        toast.error("Error while Fetching Universities Data");
        setFetchUniversitiesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Universities Data");
      console.error("Error fetching Universities:", error);
      setFetchUniversitiesLoading(false);
    }
  };

  const fetchColleges = async () => {
    try {
      setFetchCollegesLoading(true);
      const res = await getColleges();
      console.log("fetched Colleges", res?.data);
      if (res?.status) {
        setColleges(res?.data);
        setFetchCollegesLoading(false);
      } else {
        toast.error("Error while Fetching Colleges Data");
        setFetchCollegesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Colleges Data");
      console.error("Error fetching Colleges:", error);
      setFetchCollegesLoading(false);
    }
  };

  const fetchCourseCategories = async () => {
    try {
      setCourseCategoriesLoading(true);
      const res = await getCourseCategories();
      console.log("fetched Course Categories", res?.data);
      if (res?.status) {
        setCourseCategories(res?.data);
        setCourseCategoriesLoading(false);
      } else {
        toast.error("Error while Fetching Course Categories Data");
        setCourseCategoriesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Course Categories Data");
      console.error("Error fetching Course Categories:", error);
      setCourseCategoriesLoading(false);
    }
  };

  const fetchCourses = async (categoryId) => {
    try {
      setFetchCoursesLoading(true);
      const res = await getCourses();
      console.log("fetched Courses", res?.data);
      if (res?.status) {
        setCourses(res?.data.filter(item => item.categoryId === categoryId));
        setFetchCoursesLoading(false);
      } else {
        toast.error("Error while Fetching Courses Data");
        setFetchCoursesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Courses Data");
      console.error("Error fetching Courses:", error);
      setFetchCoursesLoading(false);
    }
  };

  const handleFileUpload = async (e) => {
    e.preventDefault()
    setUploading(true)
    const data = new FormData();
    data.append("file", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("file-upload", "POST", data);
      console.log("KJH124", res);

      if (res?.image) {
        setFormData({ ...formData, brochure: res.image })
        toast.success("Image uploaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Error uploading image:", error);
    } finally {
      setUploading(false)
      fileInputRef.current.value = null;
    }
  };

  const handleEdit = (data) => {
    // console.log("CDE91", data);
    setUpdateId(data?._id)

    const displayData = {
      schemeName: data?.schemeName || "",
      shortDescription: data?.shortDescription || "",
      longDescription: data?.longDescription || "",
      eligibilityCriteria: data?.eligibilityCriteria || "",
      benefits: data?.benefits || "",
    }
    setFormData(displayData)
  }

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Scholarship?",
      text: "Are you sure you want to delete this Scholarship?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        await deleteScholarship(id);
        Swal.fire("Deleted!", "Scholarship has been deleted.", "success");
        fetchAllData();
      } catch (error) {
        Swal.fire("Error!", "Failed to delete Scholarship.", "error");
      }
    }
  };

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: true,
      center: true,
    },
    {
      name: "Scheme Name",
      selector: (row) => row?.schemeName,
      sortable: true,
      wrap: true,
    },
    {
      name: "Short Description",
      selector: (row) => {return cropWords(row?.shortDescription,10)} ,
      sortable: true,
      wrap: true,
    },
    {
      name: "Long Description",
      selector: (row) => { return getPlainTextFromHtml(row?.longDescription,10) },
      sortable: true,
      wrap: true,
    },
    {
      name: "Eligibility Criteria",
      selector: (row) => {return getPlainTextFromHtml(row?.eligibilityCriteria,10)},
      sortable: true,
      wrap: true,
    },
    {
      name: "Benefits",
      selector: (row) => {return getPlainTextFromHtml(row?.benefits,10)},
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <span title="Edit">
            <i
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
              onClick={() => handleEdit(row)}
            ></i>
          </span>
          <span title="Delete">
            <i
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
              onClick={() => handleDelete(row?._id)}
            ></i>
          </span>
        </>
      ),
    },
  ];

  const handleCancel = () => {
    setUpdateId(null);
  };

  const handleUpdate = async (e) => {
    e?.preventDefault();
    if(!formData?.schemeName) return toast.error("Scheme Name should not be empty");
    if(!formData?.shortDescription) return toast.error("Please provide a short description");


    console.log("KJU388", formData);
    // return

    try {
      setUpdateLoading(true);
      const res = await updateScholarship(updateId, formData);
      console.log("Scholarship Update Message", res);
      if (res?.status) {
        toast.success(res?.message);
        setFormData(initialValues)
        setUpdateId(null);
        setUpdateLoading(false);
      } else {
        toast.error(res?.message);
        setUpdateLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add Scholarship.");
      console.error("Error adding Scholarship:", error);
      setUpdateLoading(false);
    } finally {
      fetchAllData()
    }
  };

  useEffect(() => {
    fetchAllData()
    // fetchUniversities()
    // fetchColleges()
    // fetchCourseCategories()
  }, [])

  // useEffect(() => {
  //   fetchCourses(formData.categoryId)
  // }, [formData.categoryId])

  // const [selectedExams, setSelectedExams] = useState([]);

  // useEffect(() => {
  //   const values = selectedExams.map(opt => opt.value);
  //   setFormData({ ...formData, entranceExamAccepted: values })
  // }, [selectedExams])



  return (
    <div>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          <div style={headLineStyle} className="page-headline">
            Manage Scholarship
          </div>
          {
            updateId ? (
              <>
                <section className="chartBox_area">
                  <form
                    onSubmit={(e) => {
                      handleUpdate(e);
                    }}
                  >
                    <div className="row d-flex justify-content-center">

                      <div className="col-md-12 mt-3">
                        <label htmlFor="name">
                          Scheme Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData?.schemeName}
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              schemeName: e?.target?.value,
                            }));
                          }}
                          placeholder="Enter Scholarship Scheme Name"
                          required
                        />
                      </div>

                      <div className="col-md-12 mt-3">
                        <label htmlFor="name">
                          Short Description<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData?.shortDescription}
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              shortDescription: e?.target?.value,
                            }));
                          }}
                          placeholder="Short Description"
                          required
                        />
                      </div>

                      <div className="col-md-12 mt-3">
                        <label htmlFor="longDescription">
                          Long Description
                        </label>
                        <ReactQuill
                          modules={modules}
                          theme="snow"
                          value={formData?.longDescription || ""}
                          onChange={(value) => {
                            setFormData((prev) => ({
                              ...prev,
                              longDescription: value,
                            }));
                          }}
                          placeholder="Enter Long Description"
                          style={{
                            height: "150px",
                            marginBottom: "40px",
                            fontFamily: "Poppins",
                            fontSize: "1rem"
                          }}
                        />
                      </div>

                      <div className="col-md-12 mt-3">
                        <label htmlFor="name">
                          Eligibility Criteria
                        </label>
                        {/* <textarea
                          style={{ resize: "none" }}
                          type="text"
                          id="name"
                          className="form-control"
                          value={formData?.eligibilityCriteria}
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              eligibilityCriteria: e?.target?.value,
                            }));
                          }}
                          placeholder="Enter Eligibility Criteria"
                        /> */}
                        <ReactQuill
                          modules={modules}
                          theme="snow"
                          value={formData?.eligibilityCriteria || ""}
                          onChange={(value) => {
                            setFormData((prev) => ({
                              ...prev,
                              eligibilityCriteria: value,
                            }));
                          }}
                          placeholder="Enter Eligibility Criteria"
                          style={{
                            height: "150px",
                            marginBottom: "40px",
                            fontFamily: "Poppins",
                            fontSize: "1rem"
                          }}
                        />
                      </div>

                      <div className="col-md-12 mt-3">
                        <label htmlFor="name">
                          Benefits
                        </label>
                        {/* <textarea
                          style={{ resize: "none" }}
                          type="text"
                          id="name"
                          className="form-control"
                          value={formData?.benefits}
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              benefits: e?.target?.value,
                            }));
                          }}
                          placeholder="Enter benefits"
                        /> */}
                        <ReactQuill
                          modules={modules}
                          theme="snow"
                          value={formData?.benefits || ""}
                          onChange={(value) => {
                            setFormData((prev) => ({
                              ...prev,
                              benefits: value,
                            }));
                          }}
                          placeholder="Enter benefits"
                          style={{
                            height: "150px",
                            marginBottom: "40px",
                            fontFamily: "Poppins",
                            fontSize: "1rem"
                          }}
                        />
                      </div>




                    </div>
                    {/* <div className=" d-flex justify-content-center">
                              <button
                                type="button"
                                className="btn mt-3"
                                style={{
                                  background: "#a2bae0",
                                  borderRadius: "13px",
                                }}
                              >
                                Add More
                              </button>
                            </div> */}
                    <div className=" d-flex justify-content-center" style={{ gap: "15px" }}>
                      <button
                        disabled={updateLoading}
                        type="submit"
                        className="btn mt-3"
                        style={{
                          background: "rgb(133, 218, 79)",
                          borderRadius: "13px",
                        }}
                      >
                        {updateLoading
                          ? "Saving data..."
                          : "Update Scholarship"}
                      </button>
                      <button
                        onClick={() => {
                          handleCancel();
                        }}
                        disabled={updateLoading}
                        type="button"
                        className="btn mt-3"
                        style={{
                          background: "#f77754",
                          borderRadius: "13px",
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </section>
              </>
            ) : (
              <>
                <section className="chartBox_area">
                  <DataTable
                    data={allData}
                    columns={columns}
                    pagination
                    responsive
                    highlightOnHover
                    customStyles={customStyles}
                  />
                </section>
              </>
            )
          }

        </div>
      </div>
    </div>
  );
};

export default ManageScholarship;
